import { Controller } from "@hotwired/stimulus"

// Defers loading a background <video> until it's about to scroll into view,
// so below-the-fold decorative videos don't compete with critical resources
// for bandwidth on initial page load.
export default class extends Controller {
  static values = { src: String }

  connect() {
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), { rootMargin: "200px" })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  handleIntersect(entries) {
    if (entries.some((entry) => entry.isIntersecting)) this.load()
  }

  load() {
    this.observer.disconnect()
    this.element.src = this.srcValue
    this.element.play().catch(() => {})
  }
}
